/*
  PDP-Baukasten — gemeinsames Verhalten (markenneutral)
  1. Einblenden beim Scrollen ([data-pdp-reveal])
  2. Hotspot-Karte: Seite umschalten, Punkt <-> Liste koppeln
  3. Button "zur Kaufbox" ([data-pdp-to-buy]): scrollt zur Kaufbox.
     Ziel = data-pdp-target am Button, sonst das Warenkorb-Formular der Kaufbox
     (nicht Cart Drawer / Sticky-Leiste, siehe findBuy).
  4. Videos ([data-pdp-video]): Autoplay stumm im sichtbaren Bereich, Tippen = Pause.
  5. Anleitungsvideo ([data-pdp-anl]): aktiver Schritt zur Videozeit, Klick springt.
  Mehrfach eingebunden ist harmlos — laeuft nur einmal.
*/
(function () {
  if (window.__pdpInit) return;
  window.__pdpInit = true;
  document.documentElement.classList.add('pdp-js');

  function reveal(root) {
    var els = (root || document).querySelectorAll('[data-pdp-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function zones(root) {
    (root || document).querySelectorAll('[data-pdp-zones]').forEach(function (sec) {
      if (sec.__pdp) return; sec.__pdp = true;
      var tabs = sec.querySelectorAll('[data-pdp-side-tab]');
      var stages = sec.querySelectorAll('[data-pdp-stage]');
      var items = sec.querySelectorAll('[data-pdp-zone]');

      function showSide(side) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-pdp-side-tab') === side;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        stages.forEach(function (s) { s.hidden = s.getAttribute('data-pdp-stage') !== side; });
        if (sec.hasAttribute('data-pdp-side')) sec.setAttribute('data-pdp-side', side);
      }
      function activate(id, fromList) {
        items.forEach(function (el) {
          el.classList.toggle('is-active', el.getAttribute('data-pdp-zone') === id);
        });
        if (fromList) {
          var dot = sec.querySelector('.pdp-hs__dot[data-pdp-zone="' + id + '"]');
          if (dot) showSide(dot.closest('[data-pdp-stage]').getAttribute('data-pdp-stage'));
        }
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { showSide(t.getAttribute('data-pdp-side-tab')); });
      });
      items.forEach(function (el) {
        var id = el.getAttribute('data-pdp-zone');
        var isList = !el.classList.contains('pdp-hs__dot');
        el.addEventListener('mouseenter', function () { activate(id, isList); });
        el.addEventListener('focus', function () { activate(id, isList); });
        el.addEventListener('click', function () { activate(id, isList); });
      });
    });
  }

  /* Kaufbox finden: Warenkorb-Formulare in fest positionierten Bereichen (Cart Drawer,
     Sticky-Leisten, Pop-ups) und unsichtbare Formulare (z. B. Ratenzahlung, Hoehe 0)
     zaehlen nicht. Formulare der Haupt-Produktsection (…__main / product-info) zuerst. */
  function inFixed(el) {
    for (var e = el; e && e !== document.body; e = e.parentElement) {
      if (getComputedStyle(e).position === 'fixed') return true;
    }
    return false;
  }
  /* Höhe der festen Kopfzeile (Header, Ankündigungs-/Countdown-Leiste), gemessen statt geraten */
  function topOffset() {
    var max = 0;
    document.querySelectorAll('header, sticky-header, [class*="header"], [class*="announcement"]').forEach(function (el) {
      var p = getComputedStyle(el).position;
      if (p !== 'fixed' && p !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top <= 1 && r.bottom > max && r.bottom < window.innerHeight * 0.5) max = r.bottom;
    });
    return (max || 96) + 14;
  }

  function findBuy() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'))
      .filter(function (f) { return f.offsetHeight > 0 && !inFixed(f); });
    var main = forms.filter(function (f) { return f.closest('[id*="__main"], product-info, [id^="MainProduct-"]'); });
    return main[0] || forms[0] || document.querySelector('product-info, [id^="MainProduct-"]');
  }

  function toBuy(root) {
    (root || document).querySelectorAll('[data-pdp-to-buy]').forEach(function (btn) {
      if (btn.__pdp) return; btn.__pdp = true;
      btn.addEventListener('click', function (ev) {
        var sel = btn.getAttribute('data-pdp-target');
        var cand = sel && document.querySelector(sel);
        /* Ziel aus data-pdp-target nur, wenn es sichtbar ist (z. B. Bundle-App ohne Aktion = leer) */
        var target = (cand && cand.offsetHeight > 0 && !inFixed(cand)) ? cand : findBuy();
        if (!target) return;
        ev.preventDefault();
        var y = Math.max(0, target.getBoundingClientRect().top + window.scrollY - topOffset());
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        /* Lange Wege: erst bis kurz vor das Ziel springen, dann das letzte Stück gleiten –
           sonst wirkt der Button auf langen Seiten (v. a. mobil) sekundenlang tot. */
        var hop = window.innerHeight * 0.9;
        if (!reduce && Math.abs(window.scrollY - y) > hop * 2) {
          window.scrollTo(0, y + (window.scrollY > y ? hop : -hop));
        }
        /* Gleiten erst im nächsten Frame – im selben Frame bricht Chrome (Desktop) es ab. */
        requestAnimationFrame(function () { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); });
        /* Kontrolle: Hat nachladender Inhalt die Kaufbox verschoben oder wurde das Gleiten
           unterbrochen, genau hinspringen. */
        setTimeout(function () {
          var y2 = Math.max(0, target.getBoundingClientRect().top + window.scrollY - topOffset());
          if (Math.abs(window.scrollY - y2) > 40) window.scrollTo(0, y2);
        }, 1200);
        var atc = target.querySelector('[type="submit"][name="add"], button[type="submit"]');
        if (atc) setTimeout(function () { atc.focus({ preventScroll: true }); }, 600);
      });
    });
  }

  /* 4. Videos ([data-pdp-video]): stumm, Schleife, spielen nur im sichtbaren Bereich;
        Tippen pausiert/startet. Bei reduzierter Bewegung kein Autoplay. */
  function videos(root) {
    var vids = (root || document).querySelectorAll('video[data-pdp-video]:not([data-pdp-v])');
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && !v.__pdpPaused && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!e.isIntersecting) v.pause();
      });
    }, { threshold: 0.35 }) : null;
    vids.forEach(function (v) {
      v.setAttribute('data-pdp-v', '');
      v.muted = true;
      var card = v.closest('[data-pdp-video-card]') || v;
      card.addEventListener('click', function () {
        if (v.paused) { v.__pdpPaused = false; v.play(); card.classList.remove('is-paused'); }
        else { v.__pdpPaused = true; v.pause(); card.classList.add('is-paused'); }
      });
      if (io) io.observe(v);
    });
  }

  /* 5. Anleitungsvideo ([data-pdp-anl]): Schritt zur laufenden Videozeit hervorheben,
        Klick auf einen Schritt springt im Video dorthin, Fortschrittsleiste.
        Zeiten je Schritt im Attribut data-pdp-anl-step, z. B. "12-16, 2-6" (Sekunden). */
  function anleitung(root) {
    (root || document).querySelectorAll('[data-pdp-anl]:not([data-pdp-anl-on])').forEach(function (box) {
      box.setAttribute('data-pdp-anl-on', '');
      var v = box.querySelector('video'); if (!v) return;
      var bar = box.querySelector('[data-pdp-anl-bar]');
      var steps = [].map.call(box.querySelectorAll('[data-pdp-anl-step]'), function (btn) {
        var r = (btn.getAttribute('data-pdp-anl-step') || '').split(',').map(function (x) {
          var p = x.split('-').map(parseFloat);
          return (p.length === 2 && !isNaN(p[0]) && !isNaN(p[1])) ? p : null;
        }).filter(Boolean);
        return { btn: btn, li: btn.closest('li') || btn, r: r };
      });
      var aktiv = -2, raf = null, erst = true;
      var track = box.querySelector('.pdp-anl__steps');
      var dots = box.querySelectorAll('.pdp-anl__dots i');
      var zuletztGewischt = 0;
      var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (track) ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        track.addEventListener(ev, function () { zuletztGewischt = Date.now(); }, { passive: true });
      });
      /* Mobil (Karten nebeneinander): laufende Karte ins Bild holen, außer der Nutzer wischt gerade selbst */
      function zeigeKarte(li) {
        if (!track || !li || track.scrollWidth <= track.clientWidth + 4) return;
        if (Date.now() - zuletztGewischt < 4000) return;
        var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
        var ziel = track.scrollLeft + (li.getBoundingClientRect().left - track.getBoundingClientRect().left) - pad;
        track.scrollTo({ left: ziel, behavior: ruhig ? 'auto' : 'smooth' });
      }
      var start = parseFloat(box.getAttribute('data-pdp-anl-start')) || 0;
      function tick() {
        var t = v.currentTime, d = v.duration || 0, idx = -1;
        if (bar && d) bar.style.width = Math.min(100, t / d * 100) + '%';
        steps.forEach(function (s, i) {
          if (idx < 0 && s.r.some(function (x) { return t >= x[0] && t < x[1]; })) idx = i;
        });
        if (idx !== aktiv) {
          steps.forEach(function (s, i) {
            s.li.classList.toggle('is-active', i === idx);
            if (i === idx) s.btn.setAttribute('aria-current', 'step'); else s.btn.removeAttribute('aria-current');
          });
          [].forEach.call(dots, function (d, i) { d.classList.toggle('is-active', i === idx); });
          if (idx >= 0) zeigeKarte(steps[idx].li);
          aktiv = idx;
        }
      }
      function loop() { tick(); raf = v.paused ? null : requestAnimationFrame(loop); }
      v.addEventListener('play', function () {
        if (erst) { erst = false; if (start && v.currentTime < start) v.currentTime = start; }
        if (!raf) raf = requestAnimationFrame(loop);
      });
      v.addEventListener('timeupdate', tick);
      v.addEventListener('seeked', tick);
      steps.forEach(function (s) {
        s.btn.addEventListener('click', function () {
          if (!s.r.length) return;
          erst = false;
          v.currentTime = s.r[0][0] + 0.05;
          v.__pdpPaused = false;
          var card = v.closest('[data-pdp-video-card]'); if (card) card.classList.remove('is-paused');
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          tick();
        });
      });
    });
  }

  function init(root) { reveal(root); zones(root); toBuy(root); videos(root); anleitung(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
